// extracted by mini-css-extract-plugin
export default {"table":"Table_table__2aMGv","active":"Table_active__erxsA"};